import { configureStore } from '@reduxjs/toolkit';

import AlertsManagementReducer from './slice/AlertManagementSlice';
import AlertsReducer from './slice/AlertsSlice';
import ApprovedStationManagementReducer from './slice/ApprovedStationManagementSlice';
import ChargingSessionReducer from './slice/ChargingSessionSlice';
import DeviceManagementReducer from './slice/DeviceManagementSlice';
import DynamicBasePriceManagementReducer from './slice/DynamicBasePriceManagementSlice';
import DynamicOffPeakPriceManagementReducer from './slice/DynamicOffPeakPriceManagementSlice';
import DynamicPeakPriceManagementReducer from './slice/DynamicPeakPriceManagementSlice';
import FacilityTagReducer from './slice/FacilityTagSlice';
import FileUploadStreamReducer from './slice/FileUploadStreamSlice';
import GuestChargingReducer from './slice/GuestChargingSlice';
import GuestChargingStationReducer from './slice/GuestChargingStationSlice';
import HealthFaultAnalyticsReducer from './slice/HealthFaultAnalyticsReportSlice';
import HistoricalFaultReducer from './slice/HistoricalFaultSlice';
import MaintenanceScheduleManagementReducer from './slice/MaintenanceScheduleManagementSlice';
import NotificationReducer from './slice/NotificationSlice';
import OcppMessageReducer from './slice/OcppMessageSlice';
import PageTitleReducer from './slice/PageTitleSlice';
import PenaltyAccountListReducer from './slice/PenaltyAccountListSlice';
import transactionListPenaltyReducer from './slice/PenaltyTransactionSlice';
import PendingStationManagementReducer from './slice/PendingStationManagementSlice';
import ResetReduxReducer from './slice/ReduxResetSlice';
import RejectStationManagementReducer from './slice/RejectedStationManagementSlice';
import ReportAlertsPointReducer from './slice/ReportAlertsPointSlice';
import ReportAlertsStationReducer from './slice/ReportAlertsStationSlice';
import ReportBookingPointReducer from './slice/ReportBookingPointSlice';
import ReportBookingStationReducer from './slice/ReportBookingStationSlice';
import ReportsChargerUtilizationPointReducer from './slice/ReportChargerPointSlice';
import ReportsChargerUtilizationStationReducer from './slice/ReportChargerStationSlice';
import ReportEnergyPointReducer from './slice/ReportEnergyPointSlice';
import ReportEnergyStationReducer from './slice/ReportEnergyStationSlice';
import ReportMaintenancePointReducer from './slice/ReportMaintenancePointSlice';
import ReportMaintenanceStationReducer from './slice/ReportMaintenanceStationSlice';
import ReportPerformancePointReducer from './slice/ReportPerformancePointSlice';
import ReportPerformanceStationReducer from './slice/ReportPerformanceStationSlice';
import ReportRevenuePointReducer from './slice/ReportRevenuePointSlice';
import ReportRevenueStationReducer from './slice/ReportRevenueStationSlice';
import ReportReducer from './slice/ReportSlice';
import RequestApprovedReducer from './slice/RequestApprovedSlice';
import RequestPendingReducer from './slice/RequestPendingSlice';
import RequestRejectedReducer from './slice/RequestRejectedSlice';
import RoleManagementReducer from './slice/RoleManagementSlice';
import ScheduleManagementReducer from './slice/ScheduleManagementSlice';
import softWareLogsReducer from './slice/SoftWareLogsSlice';
import StationActivityReducer from './slice/StationActivitySlice';
import StationComparisonSlice from './slice/StationComparisonSlice';
import StationDetailsReducer from './slice/StationDetailsSlice';
import stationManagementReducer from './slice/StationManagementSidePanelSlice';
import StationPerformanceReducer from './slice/StationPerformanceSlice';
import SummaryReportsReducer from './slice/SummaryReportSlice';
import TableSidePanelReducer from './slice/TableSidePanelSlice';
import TransactionReducer from './slice/TransactionManagementSlice';
import TransactionStationReducer from './slice/TransactionsStationSlice';
import UpcomingMaintenancesReducer from './slice/UpcomingMaintenanceSlice';
import UpTimeReducer from './slice/UpTimeListAndChartSlice';
import UserManagementReducer from './slice/UserManagementSlice';
import UtilizationEfficiencyReportReducer from './slice/UtilizationEfficiencyReportSlice';
import VlbcReducer from './slice/VlbcSlice';
// Store configure with the reducer
export const store = configureStore({
  reducer: {
    resetRedux: ResetReduxReducer,
    approvedStation: ApprovedStationManagementReducer,
    rejectStation: RejectStationManagementReducer,
    pendingStation: PendingStationManagementReducer,
    dynamicBasePrice: DynamicBasePriceManagementReducer,
    dynamicPeakPrice: DynamicPeakPriceManagementReducer,
    dynamicOffPeakPrice: DynamicOffPeakPriceManagementReducer,
    maintenanceSchedule: MaintenanceScheduleManagementReducer,
    roles: RoleManagementReducer,
    schedules: ScheduleManagementReducer,
    users: UserManagementReducer,
    fileUpload: FileUploadStreamReducer,
    device: DeviceManagementReducer,
    alerts: AlertsManagementReducer,
    transaction: TransactionReducer,
    notification: NotificationReducer,
    guestCharging: GuestChargingReducer,
    facilityTags: FacilityTagReducer,
    chargingSession: ChargingSessionReducer,
    vlbc: VlbcReducer,
    reportData: ReportReducer,
    reportEnergyStation: ReportEnergyStationReducer,
    reportEnergyPoint: ReportEnergyPointReducer,
    reportRevenuePoint: ReportRevenuePointReducer,
    reportRevenueStation: ReportRevenueStationReducer,
    reportBookingStation: ReportBookingStationReducer,
    reportBookingPoint: ReportBookingPointReducer,
    reportChargerPoint: ReportsChargerUtilizationPointReducer,
    reportChargerStation: ReportsChargerUtilizationStationReducer,
    reportPerformanceStation: ReportPerformanceStationReducer,
    reportPerformancePoint: ReportPerformancePointReducer,
    reportMaintenancePoint: ReportMaintenancePointReducer,
    reportMaintenanceStation: ReportMaintenanceStationReducer,
    reportAlertsPoint: ReportAlertsPointReducer,
    reportAlertsStation: ReportAlertsStationReducer,
    tableSidePanel: TableSidePanelReducer,
    stationActivity: StationActivityReducer,
    alertsStation: AlertsReducer,
    softWareLogs: softWareLogsReducer,
    HistoricalFault: HistoricalFaultReducer,
    SummaryReports: SummaryReportsReducer,
    UtilizationEfficiencyReport: UtilizationEfficiencyReportReducer,
    HealthFaultAnalyticsReport: HealthFaultAnalyticsReducer,
    transactions: TransactionStationReducer,
    guestChargingStation: GuestChargingStationReducer,
    upcomingMaintenances: UpcomingMaintenancesReducer,
    stationManagement: stationManagementReducer,
    ocppMessage: OcppMessageReducer,
    stationDetails: StationDetailsReducer,
    stationPerformance: StationPerformanceReducer,
    stationComparison: StationComparisonSlice,
    UpTime: UpTimeReducer,
    accountPenalty: PenaltyAccountListReducer,
    transactionPenalty: transactionListPenaltyReducer,
    requestApproved: RequestApprovedReducer,
    requestPending: RequestPendingReducer,
    requestRejected: RequestRejectedReducer,
    pageTitle: PageTitleReducer,
  },
});

// RootState and AppDispatch types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
